import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "cx-dh-legend-configurator",
  id: "cx-dh-legend-configurator"
}
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "legend-title" }, " Height difference legend configuration", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Apply legend", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Add range", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Add range", -1)

import { ref, Ref, onMounted, watch, computed, ComputedRef } from 'vue';
import { useStore } from 'vuex';
import { Surfacelog, SurfacelogDeltaHeightLegend } from '@/domain/surfacelog/Surfacelog';
import CxButton from '@/components/CxButton.vue';
import CxInput from '@/components/CxInput.vue';
import validatonRules from '@/components/validationRules';
import { ValidationRuleWithParams } from '@vuelidate/core';

interface ValidationRules {
  modelValue: {
    required: ValidationRuleWithParams
    cxFloat: ValidationRuleWithParams
    $autoDirty: boolean
    greaterThan?: ValidationRuleWithParams
    lessThan?: ValidationRuleWithParams
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CxDhLegendConfigurator',
  setup(__props) {

const { required, cxFloat, cxGreaterThan, cxLessThan } = validatonRules();

const store = useStore();

const legend: Ref<SurfacelogDeltaHeightLegend> = ref([]);
const rangesValidation: Ref<any> = ref(undefined);
const isFormValidated: Ref<boolean> = ref(true);
const maxRanges: Ref<number> = ref(9);
const minRanges: Ref<number> = ref(3);

const selectedEntity: ComputedRef<Surfacelog> = computed(() => store.getters['map/selectedEntity']);
const getDeltaHeightLegend: Ref<(layerUuid: string | null) => SurfacelogDeltaHeightLegend> = computed(() => (layerUuid: string | null) => store.getters['detailsSurfacelog/getDeltaHeightLegend'](layerUuid));

const changeSurfacelogLegend = (newLegend: any) => { store.dispatch('detailsSurfacelog/changeSurfacelogLegend', newLegend); };

const selectedEntityUuid = computed(() => {
  if (selectedEntity.value) {
    return selectedEntity.value.uuid;
  }
  return null;
});

const getRangesValidation = computed(() => {
  return legend.value.map((el, i) => {
    const rules: ValidationRules = {
      modelValue: {
        required,
        cxFloat,
        $autoDirty: true
      }
    };
    if (i === 0) {
      if (!Number.isNaN(parseFloat(String(legend.value[i + 1].value)))) {
        rules.modelValue.greaterThan = cxGreaterThan(legend.value[i + 1].value);
      }
      return rules;
    }
    if (i === legend.value.length - 2) {
      if (!Number.isNaN(parseFloat(String(legend.value[i - 1].value)))) {
        rules.modelValue.lessThan = cxLessThan(legend.value[i - 1].value);
      }
      return rules;
    }
    if (i === legend.value.length - 1) {
      return null;
    }
    if (!Number.isNaN(parseFloat(String(legend.value[i + 1].value)))) {
      rules.modelValue.greaterThan = cxGreaterThan(legend.value[i + 1].value);
    }
    if (!Number.isNaN(parseFloat(String(legend.value[i - 1].value)))) {
      rules.modelValue.lessThan = cxLessThan(legend.value[i - 1].value);
    }
    return rules;
  });
});

const getStartValuesArray = computed(() => {
  return legend.value.map((r, i) => {
    if (i === 0) return { value: '<' };
    return legend.value[i - 1];
  });
});

const saveLegend = () => {
  selectedEntity.value.deltaHeightLegend = legend.value;
  legend.value[legend.value.length - 1].value = legend.value[legend.value.length - 2].value - 0.01;
  changeSurfacelogLegend({ layerUuid: selectedEntityUuid.value, legend: legend.value, isOutsideRefModelVisible: selectedEntity.value.isOutsideRefModel });
};

const isRangeAddDisabled = computed(() => {
  return legend.value.length === maxRanges.value;
});

const isRangeRemoveDisabled = computed(() => {
  return legend.value.length === minRanges.value;
});

const addTopRange = () => {
  legend.value.unshift({ value: parseFloat(String(legend.value[0].value)) + 0.01, color: '#000000' });
};

const addBottomRange = () => {
  legend.value.push({ value: parseFloat(String(legend.value[legend.value.length - 1].value)) - 0.01, color: '#000000' });
};

const removeRange = (index) => {
  if (legend.value.length > minRanges.value) {
    legend.value.splice(index, 1);
  }
};

watch(selectedEntityUuid, () => {
  legend.value = getDeltaHeightLegend.value(selectedEntityUuid.value);
});

watch(
  () => legend.value,
  async () => {
    rangesValidation.value = getRangesValidation.value;
    requestAnimationFrame(() => {
      isFormValidated.value = !(document.querySelectorAll('.cx-dh-legend-configurator .cx-input-validation').length);
    });
  },
  { deep: true }
);

onMounted(async () => {
  legend.value = getDeltaHeightLegend.value(selectedEntityUuid.value);
  rangesValidation.value = getRangesValidation.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(CxButton, {
        class: "apply-legend",
        variantPrimary: "",
        disabled: !isFormValidated.value,
        onClick: saveLegend
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(CxButton, {
      class: "add-range",
      variantPrimary: "",
      flat: "",
      icon: "add",
      disabled: isRangeAddDisabled.value,
      onClick: addTopRange
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legend.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "range"
      }, [
        _createVNode(CxButton, {
          class: "remove-range",
          icon: "close",
          flat: "",
          disabled: isRangeRemoveDisabled.value,
          onClick: ($event: any) => (removeRange(index))
        }, null, 8, ["disabled", "onClick"]),
        (index !== legend.value.length - 1)
          ? (_openBlock(), _createBlock(CxInput, {
              key: 0,
              validationRules: rangesValidation.value[index],
              immediatelyShowErrors: "",
              modelValue: item.value,
              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
              type: "number",
              step: 0.1,
              class: "input-range"
            }, null, 8, ["validationRules", "modelValue", "onUpdate:modelValue"]))
          : (_openBlock(), _createBlock(CxInput, {
              key: 1,
              disabled: "",
              modelValue: "<",
              type: "text",
              class: "input-range"
            })),
        _hoisted_6,
        _createVNode(CxInput, {
          disabled: "",
          modelValue: getStartValuesArray.value[index].value,
          type: "text",
          step: 0.1,
          class: "input-range"
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("input", {
          class: "input-color",
          type: "color",
          "onUpdate:modelValue": ($event: any) => ((item.color) = $event)
        }, null, 8, _hoisted_7), [
          [_vModelText, item.color]
        ])
      ]))
    }), 128)),
    _createVNode(CxButton, {
      class: "add-range",
      variantPrimary: "",
      flat: "",
      icon: "add",
      disabled: isRangeAddDisabled.value,
      onClick: addBottomRange
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})